module.exports = __webpack_public_path__ + "img/churchhall-h-474x356.fe199f5a.jpg";